import React from 'react';

import { SVGComponentProps } from './svg.types';

const CollateralSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width="12"
        height="14"
        viewBox="0 0 12 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...otherProps}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.288 3.525V0.064L11.749 3.525H8.288ZM6.525 3.525C6.525 3.99258 6.71074 4.441 7.04137 4.77163C7.372 5.10226 7.82042 5.288 8.288 5.288H11.813V12.237C11.813 12.7046 11.6273 13.153 11.2966 13.4836C10.966 13.8143 10.5176 14 10.05 14H2.118C1.88585 14.0001 1.65596 13.9544 1.44155 13.8654C1.22714 13.7764 1.03242 13.6459 0.868592 13.4815C0.704764 13.317 0.575054 13.1217 0.486915 12.907C0.398775 12.6922 0.353945 12.4621 0.354999 12.23V1.77C0.354467 1.30162 0.539817 0.852161 0.870358 0.520308C1.2009 0.188454 1.64962 0.00132431 2.118 0L6.525 0V3.525Z"
          fill={fill}
        />
      </svg>
    </span>
  );
};

export default CollateralSVG;
